import { render, staticRenderFns } from "./1_Secteur.vue?vue&type=template&id=c5116bf0&scoped=true&"
import script from "./1_Secteur.vue?vue&type=script&lang=js&"
export * from "./1_Secteur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5116bf0",
  null
  
)

export default component.exports